module.exports = __webpack_public_path__ + "static/media/site-large.f83818c6.png";